export default "__VITE_ASSET__CkHcM_sG__"